import { FormField } from '@/components/custom/erp';
import { provinceColumns } from '../../cols-definition';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface FormProps {
  mode: FormMode;
}
function DistrictForm({ mode }: FormProps) {
  return (
    <div className='p-4 md:p-6'>
      <div className='flex flex-col gap-y-4 md:gap-y-6'>
        <div className='space-y-4 md:space-y-6'>
          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã quận/huyện</Label>
            <FormField type='text' name='ma_quan' disabled={mode === 'view'} defaultValue='' />
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên quận/huyện</Label>
            <FormField type='text' name='ten_quan' disabled={mode === 'view'} defaultValue='' />
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên khác</Label>
            <FormField type='text' name='ten_quan2' disabled={mode === 'view'} />
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label htmlFor='ma_tinh' className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>
              Mã tỉnh/thành
            </Label>
            <FormField
              id='ma_tinh'
              type='text'
              name='ma_tinh'
              withSearch
              searchEndpoint={`/provinces`}
              searchColumns={provinceColumns}
              disabled={mode === 'view'}
            />
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label htmlFor='trang_thai' className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>
              Trạng thái
            </Label>
            <FormField
              id='trang_thai'
              type='select'
              name='trang_thai'
              defaultValue={1}
              options={[
                { label: '1. Còn sử dụng', value: 1 },
                { label: '2. Không sử dụng', value: 2 }
              ]}
              disabled={mode === 'view'}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DistrictForm;
